module.exports = __webpack_public_path__ + "static/media/anggaran.1d99a40f.png";